
import { Stack } from "react-bootstrap";

const Tag = ({text, icon}) => {
    return (
        <div className="tag">
            <Stack direction="horizontal" className="">
                {   
                    icon!=null 
                    ?   <div className="me-1 tag-icon ">
                            {icon()}
                        </div>
                    : null
                }
                <div >
                    <p className="tag-text text-start">{text}</p>
                </div>
            </Stack>
        </div>
    );
}

export default Tag; 